import React from "react";

interface FilePreviewProps {
  src: string;
  name: string;
  isPdf: boolean;
  onClick?: () => void;
  zoomed?: boolean;
  showName?: boolean;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  src,
  name,
  isPdf,
  onClick,
  zoomed = false,
  showName = true,
}) => {
  return (
    <div className="flex flex-col items-center">
      {isPdf ? (
        <object
          data={src}
          type="application/pdf"
          className="w-full h-[300px] border rounded-md shadow"
          onClick={onClick}
        >
          <p>
            Unable to load PDF.{" "}
            <a href={src} target="_blank" rel="noopener noreferrer">
              Click here to view
            </a>
          </p>
        </object>
      ) : (
        <img
          src={src}
          alt={name}
          onClick={onClick}
          className={`max-w-full max-h-[300px] object-cover rounded-lg shadow-lg ${
            zoomed ? "cursor-zoom-out scale-150" : "cursor-zoom-in"
          } transition-transform duration-300`}
        />
      )}
      {showName && (
        <div className="text-xs mt-2 text-center break-words">{name}</div>
      )}
    </div>
  );
};

export default FilePreview;
